var isInViewport = function (elem) {
	var distance = elem.getBoundingClientRect();
	return (
		distance.top >= 0 &&
		distance.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
		distance.right <= (window.innerWidth || document.documentElement.clientWidth)
	);
};


document.addEventListener('DOMContentLoaded', function () {
	AOS.init({
		once: true,
		offset: 0
	});
});


document.addEventListener('DOMContentLoaded', function () {

	var footerCircle = document.getElementById('footer-circle');
	window.addEventListener('scroll', function () {
		if (isInViewport(footerCircle)) {
			footerCircle.classList.add('visible');
		}
	}, false);

});
